
import { motion } from "framer-motion";

export const ArabicFinancialSystem = () => {
  return (
    <div className="bg-blue-50 p-6 rounded-lg mb-8">
      <h2 className="text-xl font-semibold mb-4 text-blue-800">كيف تعمل القروض في فنلندا</h2>
      <p className="mb-4">
        تتمتع فنلندا بنظام مصرفي مستقر وآمن مع أسعار فائدة تنافسية. تتطلب جميع طلبات القروض رقم هوية فنلندي (henkilötunnus) وعادة ما تتحقق من معلوماتك الائتمانية من خلال سجل Suomen Asiakastieto.
      </p>
      <p className="mb-4">
        تتطلب معظم القروض في فنلندا:
      </p>
      <ul className="list-disc pr-5 mb-4 space-y-2">
        <li>دخل منتظم وتاريخ ائتماني جيد</li>
        <li>الجنسية الفنلندية أو الإقامة الدائمة</li>
        <li>العمر 18 عامًا على الأقل (بعض القروض تتطلب 20+ عامًا)</li>
        <li>عدم وجود تخلف عن السداد أو حظر ائتماني</li>
      </ul>
      <p>
        مع Lainasampo.fi، يمكنك إكمال طلب واحد واستلام عروض قروض متعددة من مختلف البنوك والمؤسسات المالية الفنلندية، مما يوفر لك الوقت وربما يضمن أسعار فائدة أفضل.
      </p>
    </div>
  );
};
